import React from "react";

const GetMedalGetJob=()=>{
    return(
    <>
        <h1>Get Medal get job</h1>
    </>
    )
}
export default GetMedalGetJob